import {
    Box,
    Button,
    CrudMode,
    DataArray,
    DataDisplay,
    Grid,
    GridBreak,
    pn,
    Stack,
    useElementBreakpoints,
    ValidationErrors,
} from "@compass/core";
import { Input, Select } from "components";
import { DisciplineEditResource, DisciplineViewResource, Discipline } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const DisciplinePageBody = (props: {
    crudMode: CrudMode;
    discipline: Discipline;
    setDiscipline: (value: Discipline) => void;
    viewResource: DisciplineViewResource;
    editResource: DisciplineEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints, fullFieldBreakpoints } =
        useElementBreakpoints();

    const properties = props.viewResource.properties || [];

    const nameField = () => {
        const propertyName = pn<Discipline>("name");
        const property = properties.find((x) => x.propertyName === propertyName);

        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.discipline.name}</DataDisplay>
        ) : (
            <Input
                modelProperty={property}
                errors={props.validationErrors[propertyName]}
                value={props.discipline.name}
                onChange={(e) =>
                    props.setDiscipline(
                        produce(props.discipline, (draft) => {
                            draft.name = e.target.value;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={smallFieldBreakpoints}>
                {nameField()}
            </Grid>
            <GridBreak />
        </Grid>
    );
};